import { trackRenterProfileEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';

const EVENT_TEMPLATE_ID = '175';

export const RACHEL_ARCHIVE_CONVERSATION_EVENT_TYPE_ID = '7890';
// https://dataportal.zillowgroup.net/event-registry/7890
export const emitRachelArchiveConversationEvent = () =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: RACHEL_ARCHIVE_CONVERSATION_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'archive_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    renter_profile: null,
  });

export const RACHEL_UNARCHIVE_CONVERSATION_EVENT_TYPE_ID = '7892';
// https://dataportal.zillowgroup.net/event-registry/7892
export const emitRachelUnarchiveConversationEvent = () =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: RACHEL_UNARCHIVE_CONVERSATION_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'unarchive_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
    renter_profile: null,
  });
